import type { HelpFile } from '../../types/help'
import { ImpersonationBannerTestIds } from '../../../testids/ImpersonationBannerTestIds'

export const impersonationBannerHelp: HelpFile = {
  docPage: '/docs/admin/impersonation',
  texts: {
    [ImpersonationBannerTestIds.impersonatedUserName]: 'Active impersonation session — all actions are recorded against the real identity in the audit log.',
    [ImpersonationBannerTestIds.btnSwitchBack]: 'Stop impersonating and return to your own account.',
  },
}
